import { required, SelectInput } from "react-admin";
import { subcontractorHolidayPaymentPricingTypeList } from "../const";

interface ISubcontractorHolidayPaymentPricingTypeInput {
  callback?: (x: string) => void;
}

const SubcontractorHolidayPaymentPricingTypeInput = (
  props: ISubcontractorHolidayPaymentPricingTypeInput,
) => {
  return (
    <SelectInput
      source="pricingType"
      label="PricingType"
      choices={subcontractorHolidayPaymentPricingTypeList}
      validate={required()}
      onChange={({ target }) => {
        props.callback && props.callback(target.value);
      }}
    />
  );
};

export default SubcontractorHolidayPaymentPricingTypeInput;
